<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("common.overview") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <!-- REPORT INFORMATION -->
        <div class="md-layout-item md-size-33 md-small-size-100 ml-[-15px]">
          <information-area
            :title="$t('score_report.overview.area_report_information')"
          >
            <template #content>
              <div class="infos mb-4">
                <p class="font-normal">
                  {{ $t("common.term") }}:
                  {{ termName }}
                </p>
              </div>
              <div class="results flex mt-20">
                <result-box
                  icon="assignment_turned_in"
                  :resultTxt="summary.total_students"
                  :title="$t('dashboard.synthetic.total_students')"
                  :class="['result-box-color']"
                  v-if="summary.total_students !== ''"
                ></result-box>
                <result-box
                  icon="assignment_turned_in"
                  :resultTxt="summary.average"
                  :title="$t('attendance_report.student.average_gpa')"
                  :class="['result-box-color', 'ml-4']"
                  v-if="summary.average !== ''"
                ></result-box>
              </div>
            </template>
          </information-area>
        </div>
        <!-- REPORT INFORMATION -->

        <!-- GRADE LETTER -->
        <div class="md-layout-item md-size-33 md-small-size-100">
          <information-area
            :title="$t('score_report.overview.area_grade_letter')"
          >
            <template #content
              ><grade-chart :grade-letter="gradeLetter"></grade-chart
            ></template>
          </information-area>
        </div>
        <!-- GRADE LETTER -->

        <!-- GPA CHART -->
        <div class="md-layout-item md-size-33 md-small-size-100">
          <information-area :title="$t('score_report.overview.gpa')">
            <template #content>
              <template v-if="hasGpaTopData">
                <p>
                  <Trophy class="inline-block mr-2" />
                  <span class="font-medium text-gray-600">{{
                    $t("attendance_report.student.top_gpa")
                  }}</span>
                </p>
                <gpa-chart :gpa-tops="gpaTops"></gpa-chart>
              </template>
              <no-data-found class="mx-auto" v-else></no-data-found>
            </template>
          </information-area>
        </div>
        <!--  GPA CHART -->
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { InformationArea, ResultBox } from "../../Components";
import GradeChart from "./GradeChart.vue";
import GpaChart from "./GpaChart.vue";
import Trophy from "@/components/Base/Icons/Trophy.vue";
import NoDataFound from "@/components/Base/Illustration/NoDataFound.vue";

export default {
  components: {
    InformationArea,
    ResultBox,
    GradeChart,
    GpaChart,
    Trophy,
    NoDataFound
  },
  inject: ["reportParams", "basePath"],
  data() {
    return {
      summary: { total_students: "", average: "" },
      gradeLetter: null,
      gpaTops: null
    };
  },
  methods: {
    async fetchReportOverview(searchingParams) {
      return Promise.all([
        this.fetchSummary(searchingParams),
        this.fetchGradeLetter(searchingParams),
        this.fetchGPATops(searchingParams)
      ]);
    },
    async fetchSummary(searchingParams) {
      return this.$axios
        .get(
          `${this.basePath}/score/summary`,
          searchingParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.summary = data;
        });
    },
    async fetchGradeLetter(searchingParams) {
      return this.$axios
        .get(
          `${this.basePath}/score/grade-letter`,
          searchingParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.gradeLetter = data;
        });
    },
    async fetchGPATops(searchingParams) {
      const queryParams = {
        ...searchingParams,
        limit: 10
      };

      return this.$axios
        .get(
          `${this.basePath}/gpa/top-gpa`,
          queryParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.gpaTops = data;
        });
    }
  },
  computed: {
    termName() {
      return this.reportParams.searchingTerm?.name;
    },
    hasGpaTopData() {
      return this.gpaTops?.data?.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.result-box-color {
  color: #2d82b5;

  width: 156px;
}

.infos {
  p {
    @apply leading-7;
  }
}
</style>
